export enum LineDelveTypes {
  GET_LINE_DELVE_DETAILS = 'GET_LINE_DELVE_DETAILS',
  SET_LINE_DELVE_DETAILS = 'SET_LINE_DELVE_DETAILS',
  RESET_LINE_DELVE_DETAILS = 'RESET_LINE_DELVE_DETAILS',
  SET_LOADING = 'SET_LOADING',
  FILTER_LINE_DELVE_DETAILS = 'FILTER_LINE_DELVE_DETAILS',
  REMOVE_GRANTEE_EMAIL = 'REMOVE_GRANTEE_EMAIL',
  REMOVE_GRANTEE_SUCCESS = 'REMOVE_GRANTEE_SUCCESS',
  REMOVE_LINEDELVE_STATUS = 'REMOVE_LINEDELVE_STATUS',
  LINE_DELVE_STATUS = 'LINE_DELVE_STATUS',
  REMOVE_GRANTEE_FAIL = 'REMOVE_GRANTEE_FAIL',
  UPDATE_ERROR = 'UPDATE_ERROR',
  RESET_ATTEMPTS = 'RESET_ATTEMPTS',
  GET_DEVICE_LIST = 'GET_DEVICE_LIST',
  SET_DEVICE_LIST = 'SET_DEVICE_LIST',
  GET_PRIMARY_DEVICE = 'GET_PRIMARY_DEVICE',
  SET_PRIMARY_DEVICE = 'SET_PRIMARY_DEVICE',
  DEACTIVATE_LINE = 'DEACTIVATE_LINE',
  SUCCESS_DEACTIVATE_LINE = 'SUCCESS_DEACTIVATE_LINE',
  ERROR_DEACTIVATE_LINE = 'ERROR_DEACTIVATE_LINE',
  SET_PAIRED_LINE = 'SET_PAIRED_LINE',
  GET_PAIRED_LINE = 'GET_PAIRED_LINE',
}
